module.exports = __webpack_public_path__ + "img/28_74.3348a6ea.png";